import React  from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";


export default function OtherInfoHeader2() {
    let applicant = ApplicantContainer.useContainer();

    return (
        applicant.showOtherInfoHeader2 ?
        <>
        <Form.Row>
          <Col xs={12}>
            <Form.Group as={Col} controlId="formName" className="border-bottom border-dark mt-4 mb-4">
              <Form.Label className="section-header">SECTION C: {applicant.showOtherInfoHeader2}</Form.Label>
            </Form.Group>
          </Col>  
        </Form.Row>
        </>
        :
        <></>);
}